import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { editorMessages } from '../messages/editorMessages';
import { PreviewFrame } from './PreviewFrame';
import { Transport } from './Transport';
import styles from './PreviewStage.module.scss';

/** The center of the editor (design b1): the live preview, its transport and the safe area switch. */
const PreviewStageComponent: React.FC = () => {
  const intl = useIntl();
  const { transport } = useMusicVideoEditor();
  const [showSafe, setShowSafe] = useState(false);
  return (
    <div className={styles.stage}>
      <PreviewFrame showSafe={showSafe} acceptsDrop />
      <Transport showSafe={showSafe} onToggleSafe={() => setShowSafe((value) => !value)} />
      {!transport.canPlay && <p className={styles.noSound}>{intl.formatMessage(editorMessages.noSound)}</p>}
    </div>
  );
};

export const PreviewStage = TypedMemo(PreviewStageComponent);
